<template>
  <div class="LoginView container flex flex-col lg-justify-center">
    <div class="mb-24 grid col-1 lg-col-2 pb-40">
      <div class="LoginView__left lg-pr-112">
        <template v-if="productionTip">
          <div>
            <img
              v-if="productionTip.Image"
              class="w-full hide md-d-block"
              :src="`${productionTip.Image.data.attributes.url}`"
              alt=""
            />
            <div class="hide lg-d-block">
              <h2 class="font-family-display font-weight-bold mb-24">
                {{ productionTip.Title }}
              </h2>
              <p>{{ productionTip.Text }}</p>
            </div>
          </div>
        </template>
      </div>
      <div class="LoginView__right pt-40 md-pt-0">
        <div>
          <h1 class="font-family-display font-weight-bold mb-8">
            {{ $t('new_password') }}
          </h1>
          <p class="mb-24">
            {{ $t('enter_new_password') }}
          </p>

          <ChangePasswordForm
            :is-loading="loading"
            @send-form="sendNewPassword"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import recoverPassServices from '../../api/services/recoverPassServices'
import { storeToRefs } from 'pinia'
import { useChangePasswordStore } from '@/stores/changePasswordStore'
import { useCmsStore } from '@/stores/cmsStore'
import ChangePasswordForm from '@/components/forms/ChangePasswordForm.vue'
import { useRouter } from 'vue-router'
import { useNotificationsStore } from '@/stores/notificationsStore'

const props = defineProps({
  token: {
    type: String,
    default: ''
  }
})

const loading = ref(false)

const router = useRouter()

const cmsStore = useCmsStore()
const { setNotification } = useNotificationsStore()
const { setHasChangedPasswordSuccess } = useChangePasswordStore()
const { productionTip } = storeToRefs(cmsStore)

async function sendNewPassword(form) {
  try {
    await recoverPassServices.postResetNewPassword({
      token: props.token,
      password: form.newPassword,
      passwordRepeat: form.repeatNewPassword
    })
    setHasChangedPasswordSuccess(true)
    await router.push({ name: 'PasswordResetSuccessView' })
  } catch (e) {
    setNotification({
      header: e.message,
      body: 'An error occurred',
      type: 'danger'
    })
  } finally {
    loading.value = false
  }
}
</script>
